import React from "react";
import { connect } from "react-redux";

import CurrentPlan from "@mapmycustomers/shared/types/plans/CurrentPlan";
import Tier from "@mapmycustomers/shared/types/plans/Tier";

import { RootState } from "@app/store/rootReducer";

import { getLicenses, getPriceInfo } from "../../store";
import { getProrateRatioDetails, PriceInfo } from "../../util/price";

import AdjustedPriceRow from "./AdjustedPriceRow";
import DueTodayRow from "./DueTodayRow";
import ProratedPriceRow from "./ProratedPriceRow";
import TotalRow from "./TotalRow";

interface Props {
  currentPlan: CurrentPlan;
  licenses: number;
  priceInfo: PriceInfo;
  selectedTier: Tier;
}

const SummaryRows: React.FC<Props> = ({ currentPlan, licenses, priceInfo, selectedTier }) => {
  const { daysInCurrentBillingCycle, remainingDays } = getProrateRatioDetails(currentPlan);
  const { adjustedPrice, dueTodayPrice, proratedPrice, subscriptionPrice, switchingToAnnual } =
    priceInfo;

  const showAdjustedPrice = !currentPlan.tier.isTrial && adjustedPrice.value !== 0;
  const showProratedPrice = !currentPlan.tier.isTrial && proratedPrice.value !== 0;

  return (
    <>
      <TotalRow licenses={licenses} price={subscriptionPrice} selectedTier={selectedTier} />

      {showAdjustedPrice && (
        <AdjustedPriceRow
          currentPlan={currentPlan}
          daysInCurrentBillingCycle={daysInCurrentBillingCycle}
          price={adjustedPrice}
          remainingDays={remainingDays}
          selectedTier={selectedTier}
          switchingToAnnual={switchingToAnnual}
        />
      )}

      {showProratedPrice && !switchingToAnnual && (
        <ProratedPriceRow
          daysInCurrentBillingCycle={daysInCurrentBillingCycle}
          licensesAfter={licenses}
          licensesBefore={currentPlan.licenses}
          price={proratedPrice}
          remainingDays={remainingDays}
          selectedTier={selectedTier}
          switchingToAnnual={switchingToAnnual}
        />
      )}

      <DueTodayRow
        hasAdjustedPrice={showAdjustedPrice}
        hasProratedPrice={showProratedPrice}
        isCurrentPlanTrial={currentPlan.tier.isTrial ?? false}
        price={dueTodayPrice}
        switchingToAnnual={switchingToAnnual}
      />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  licenses: getLicenses(state),
  priceInfo: getPriceInfo(state),
});

export default connect(mapStateToProps)(SummaryRows);
